import Alerter from "@/common/alerter"
import { DataContext } from "@/contexts"
import { formatDateKeepZone } from "@/helpers/dates"
import CloseIcon from "@mui/icons-material/Close"
import { Box, Dialog, IconButton, Stack, Typography } from "@mui/material"
import React, { useContext } from "react"
import { Button } from "react-bootstrap"
import { MeetingFormatTitles } from "../constants"
import { QueryContext } from "@/contexts"
import { bulkDeleteSessionInSchedule } from "../configurations/domain"

export const NewDeleteSessionDialog = ({ show, onClose, session }) => {
  const { schedule } = useContext(DataContext)
  const { educatable, meeting_format } = schedule
  const { getRequest } = useContext(QueryContext)

  const onSubmit = async e => {
    e.preventDefault()
    try {
      const request = getRequest(bulkDeleteSessionInSchedule)
      await request({ data: { bulk: { ids: [session.id] } } })
      onClose()
    } catch (error) {
      Alerter.error("Error while deleting session.")
    }
  }

  return (
    <Dialog
      open={show}
      onClose={onClose}
      fullWidth
      PaperProps={{
        elevation: 6,
      }}
    >
      <div className="p-4">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "60px",
            backgroundColor: "white",
            borderRadius: "16px 16px 0px 0px",
          }}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
            <Typography variant="h5">Delete session</Typography>
            <IconButton aria-label="close" size="medium" onClick={onClose}>
              <CloseIcon fontSize="medium" />
            </IconButton>
          </Stack>
        </Box>
        <span className="font-weight-semibold">
          {educatable.name} on {meeting_format === "online" ? "Web" : MeetingFormatTitles[meeting_format]},{" "}
          {formatDateKeepZone(session.started_at, "MMMM D, h:mma")}
        </span>
        <div>
          <form onSubmit={onSubmit}>
            <div className="d-flex justify-content-between align-items-center mb-3 pt-3 pb-3">
              <span className="mb-0 mt-2">
                Only delete a session if it was added by mistake. Do not delete the session if the student(s)
                didn&apos;t show up or it was canceled by agreement.
              </span>
            </div>

            <div className="d-flex justify-content-end mt-4">
              <Button variant="outline-primary" onClick={() => onClose()} className="mr-2">
                Cancel
              </Button>
              <Button variant="danger" type="submit">
                Delete
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
  )
}
